// TODO(imaman): dedup with PublisherSlug in update-review-decision-api.ts
export type PublisherSlug = 'mashbir' | 'dix30' | 'royalmount'

type KnownPublisher = {
  slug: PublisherSlug
  displayName: PublisherDisplayName
  domain: string
  description: string
  isEnabled: boolean
}

// TODO(imaman): get rid of this type. Seems that it can be just a plain string.
type PublisherDisplayName = 'Mashbir' | 'Quartier DIX30' | 'Royalmount'

export const knownPublishers: KnownPublisher[] = [
  {
    slug: 'mashbir',
    displayName: 'Mashbir',
    domain: '365mashbir.co.il',
    description: 'Shopping destination',
    isEnabled: true,
  },
  {
    slug: 'dix30',
    displayName: 'Quartier DIX30',
    domain: 'quartierdix30.com',
    description: 'Lifestyle and entertainment complex',
    isEnabled: false,
  },
  {
    slug: 'royalmount',
    displayName: 'Royalmount',
    domain: 'royalmount.com',
    description: 'Premium shopping destination',
    isEnabled: true,
  },
]
